import type { ReactNode } from "react";
import SiteHeader from "./SiteHeader.tsx";
import SiteFooter from "./SiteFooter.tsx";
import CartDrawer from "../cart/CartDrawer.tsx";

export default function PageFrame({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      <CartDrawer />
    </div>
  );
}
